import { routes } from '@/app/routing/router'
import { TransactionStatusView } from './view'
const currentRoute = routes.transactionStatus

const TransactionStatusRoute = {
  route: currentRoute,
  view: TransactionStatusView,
}

export { currentRoute, TransactionStatusRoute }
